document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('CustomNewsletterForm');
  const firstNameInput = document.getElementById('CustomNewsletterFirstName');
  const lastNameInput = document.getElementById('CustomNewsletterLastName');
  const emailInput = document.getElementById('CustomNewsletterEmail');
  const agreeInput = document.getElementById('CustomNewsletterAgree');
  const subscribeBtn = document.getElementById('CustomNewsletterSubscribe');
  const subscribeBtnText = subscribeBtn.querySelector('span');

  const firstNameError = document.getElementById('CustomNewsletterFirstNameError');
  const lastNameError = document.getElementById('CustomNewsletterLastNameError');
  const emailError = document.getElementById('CustomNewsletterEmailError');
  const agreeError = document.getElementById('CustomNewsletterAgreeError');

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function clearErrors() {
    [firstNameInput, lastNameInput, emailInput, agreeInput].forEach((input) => {
      input.classList.remove('has-error');
    });
    [firstNameError, lastNameError, emailError, agreeError].forEach((el) => {
      el.style.display = 'none';
      el.textContent = '';
    });
  }

  function showError(input, errorEl, message) {
    input.classList.add('has-error');
    errorEl.textContent = message;
    errorEl.style.display = 'block';
  }

  // Clear error on input
  [firstNameInput, lastNameInput, emailInput].forEach((input) => {
    input.addEventListener('input', clearErrors);
  });
  agreeInput.addEventListener('change', clearErrors);

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearErrors();
    let hasError = false;
    const firstName = firstNameInput.value.trim();
    const lastName = lastNameInput.value.trim();
    const email = emailInput.value.trim();
    const agreed = agreeInput.checked;

    if (!firstName) {
      showError(firstNameInput, firstNameError, 'This is a required field.');
      hasError = true;
    }
    if (!lastName) {
      showError(lastNameInput, lastNameError, 'This is a required field.');
      hasError = true;
    }
    if (!email) {
      showError(emailInput, emailError, 'This is a required field.');
      hasError = true;
    } else if (!validateEmail(email)) {
      showError(emailInput, emailError, 'Please enter a valid email address.');
      hasError = true;
    }
    if (!agreed) {
      showError(agreeInput, agreeError, 'This is a required field.');
      hasError = true;
    }
    if (hasError) return;

    // Simulate success (no backend call)
    subscribeBtn.disabled = true;
    subscribeBtnText.textContent = 'Subscribed!';
    firstNameInput.value = '';
    lastNameInput.value = '';
    emailInput.value = '';
    agreeInput.checked = false;
    setTimeout(() => {
      subscribeBtn.disabled = false;
      subscribeBtnText.textContent = 'SUBSCRIBE';
    }, 3000);
  });
});
